<template>
    <div>
        <div>
            <a-tabs defaultActiveKey="1" :tabPosition="top">
                <a-tab-pane tab="正在学习" key="1">
                    <div class="classList" v-if="!isHaveMyStudyList">
                        <ul>
                            <li v-for="item in 4" :key="item">
                                <spin></spin>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <div v-if="myStudyList.length==0">
                            <a-empty style="margin-bottom: 10px" description="暂无数据..."/>
                        </div>

                        <div v-else class="classList">
                            <ul>
                                <li v-for="item in myStudyList" :key="item.courseId">
                                    <course-list-item :course-info="item"/>
                                    <dt>
                                        <a-progress :percent="(item.learnedSectionNum)*100/item.subSectionNum"
                                                    :showInfo="false" strokeColor="#00CF8C" size="small"/>
                                    </dt>
                                    <dt style="color: #00CF8C">已学习{{item.learnedSectionNum}}/{{item.subSectionNum}}课时
                                    </dt>
                                </li>
                            </ul>
                        </div>
                    </div>
                </a-tab-pane>

                <a-tab-pane tab="我的收藏" key="2">
                    <div class="classList" v-if="!isHaveCollectList">
                        <ul>
                            <li v-for="item in 4" :key="item">
                                <spin></spin>
                            </li>
                        </ul>
                    </div>

                    <div v-else>
                        <div v-if="collectList.length == 0">
                            <a-empty style="margin-bottom: 10px" description="暂无数据..."/>
                        </div>
                        <div v-else class="classList">
                            <ul>
                                <li v-for="item in collectList" :key="item.courseId">
                                    <CourseListItem :course-info="item"/>
                                </li>
                            </ul>
                        </div>
                    </div>

                </a-tab-pane>

                <a-tab-pane tab="我的报名" key="4">
                    <div class="classList" v-if="!isHaveSignup">
                        <ul>
                            <li v-for="item in 4" :key="item">
                                <spin></spin>
                            </li>
                        </ul>
                    </div>

                    <div v-else>
                        <div v-if="liveCourseSignupList.length == 0">
                            <a-empty style="margin-bottom: 10px" description="暂无数据..."/>
                        </div>
                        <div v-else class="classList">
                            <ul>
                                <li v-for="item in liveCourseSignupList" :key="item.courseId">
                                    <CourseListItem :course-info="item.course" :isLiveSignUp="true"/>
                                </li>
                            </ul>
                        </div>
                    </div>

                </a-tab-pane>

                <a-tab-pane tab="观看记录" key="3">
                    <div class="classList" v-if="!isHaveRecordList">
                        <div class="example">
                            <a-spin/>
                        </div>
                    </div>

                    <div v-else>
                        <div v-if="recordList.length == 0">
                            <!--                        <header>暂无观看记录</header>-->
                            <a-empty style="margin-bottom: 10px" description="暂无数据..."/>
                        </div>
                        <div v-else>
                            <div class="watchList" v-for="(mydata,key) in recordList" :key="key">
                                <header>{{mydata.updatedTime}}</header>
                                <ul class="watchList-ul">
                                    <!--                                <li><img src="../assets/img/null.png" alt=""></li>-->
                                    <li><img :src=mydata.coverFileUrl alt=""></li>
                                    <li>{{mydata.courseTitle}}</li>
                                    <li style="float: right">
                                        <router-link
                                                :to="{name:'courseDetail',params: { courseId: mydata.courseId }}">
                                            <a-button type="primary">播放</a-button>
                                        </router-link>
                                    </li>
                                    <div style="clear: both"></div>
                                </ul>

                                <dl class=" watchList-dl ">
                                    <a-row :gutter="{ xs: 8, sm: 16, md: 24, lg: 32 }" style="display: flex">
                                        <a-col :span="12">
                                            <dt>
                                                <img :src=mydata.coverFileUrl alt="">
                                            </dt>
                                        </a-col>
                                        <a-col :span="12">
                                            <div class="watchList-dt">
                                                <dt>{{mydata.courseTitle}}</dt>
                                                <dt>
                                                    <router-link
                                                            :to="{name:'courseDetail',params: { courseId: mydata.courseId }}">
                                                        <a-button type="primary">播放</a-button>
                                                    </router-link>
                                                </dt>
                                            </div>
                                        </a-col>
                                    </a-row>
                                </dl>
                            </div>
                        </div>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
    import {myCourse, signupList} from "@api/personal-api"
    import spin from "@components/loading/Spin"
    import CourseListItem from "@components/course/CourseListItem";

    export default {
        name: "myCourse",
        components: {
            CourseListItem,
            spin
        },
        data() {
            return {
                top: "top",
                //是否有正在学习内容
                isHaveMyStudyList: false,
                //正在学习
                myStudyList: [],
                // 是否有观看记录
                isHaveRecordList: false,
                //观看记录
                recordList: [],
                //我的收藏列表
                isHaveCollectList: false,
                collectList: [],
                //    是否有报名记录
                isHaveSignup: false,
                liveCourseSignupList: [],
            }
        },
        created() {
            //   我的课程信息 myCourse
            myCourse().then((res) => {
                if (res.code == 0) {
                    this.isHaveMyStudyList = true
                    this.isHaveCollectList = true
                    this.isHaveRecordList = true
                    this.myStudyList = res.myStudyList
                    this.collectList = res.collectList
                    this.recordList = res.recordList
                }
            })

            //   我的课程信息 myCourse
            signupList().then((res) => {
                if (res.code == 0) {
                    this.isHaveSignup = true
                    this.liveCourseSignupList = res.liveCourseSignupList
                }
            })
        },
    }
</script>

<style scoped lang="less">
    @import "../../styles/course.less";

    .classList {
        width: 100%;
        padding: 10px;
        background: white;

        ul {
            li {
                width: 25%;
                padding: 0 17px;

                dt {
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }

    .watchList {
        border: 1px solid #e8e8e8;
        margin-bottom: 20px;
        background: white;

        header {
            font-size: 16px;
            color: black;
            height: 30px;
            line-height: 30px;
            background: white;
            padding-left: 20px;
            border-bottom: 1px solid #F4F4F4;
        }

        ul {
            li {
                float: left;
                margin: 20px;
                height: 100px;

                img {
                    width: 156px;
                    height: 100%;
                }
            }

            li:nth-of-type(2) {
                width: 300px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 5;
                overflow: hidden;
                line-height: 50px;
            }

            li:nth-of-type(3) {
                line-height: 100px;
            }
        }
    }

    .example {
        text-align: center;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 4px;
        padding: 50px;
        width: 100%;
    }

    .watchList-dl {
        display: none;
    }


    @import '../../styles/variable.less';
    @media screen and (max-width: @screen-xxl) {
        .classList {
            ul {
                li {
                    width: 20%;
                    padding: 0 10px;
                }
            }
        }
    }

    @media screen and (max-width: @screen-xl) {
        .classList {
            ul {
                li {
                    width: 25%;
                }
            }
        }
    }

    @media screen and (max-width: @screen-lg) {
        .classList {
            ul {
                li {
                    width: 33.33%;
                    padding: 0 10px;
                }
            }
        }
    }

    @media screen and (max-width: @screen-md) {

        button {
            /*width: 50px;*/
            font-size: 14px;
        }
        .classList {
            ul {
                li {
                    width: 50%;
                    padding: 0 10px;
                }
            }
        }

        .watchList {
            header {
                font-size: 14px;
                color: #0c0c0cdb;
            }
        }


        .watchList-dl {
            padding: 10px;
            display: block;

            img {
                width: 100%;
                /*height: 130px;*/
            }

            /*dt {*/
            /*    min-height: 45px;*/
            /*    !*overflow: hidden;*!*/
            /*    !*text-overflow: ellipsis;*!*/
            /*    !*white-space: nowrap;*!*/
            /*    display: -webkit-box;*/
            /*    -webkit-box-orient: vertical;*/
            /*    -webkit-line-clamp: 2;*/
            /*    overflow: hidden;*/
            /*}*/
            /*dt:nth-of-type(2){*/
            /*    text-align: right;*/
            /*}*/
        }

        .watchList-dt {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-between;
            align-content: space-between;

            dt {
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
            }

            dt:nth-of-type(2) {
                text-align: right;
            }
        }

        .watchList-ul {
            display: none;
        }

    }



</style>
